var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPedido(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 244,
    viewBox: "0 0 236 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.2 239C176.2 241.3 169.7 243 163 243.5H157.9H96.1H67C34.2 243.5 6.6 219.9 0 188.6H139.4C144.3 211.8 160.7 230.7 182.2 239Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.2 242.4C161.3 242.4 158.1 239.4 157.8 235.5C157.5 231.4 160.6 227.8 164.6 227.5C196.3 225.1 221.1 198.1 221.1 165.9V14.9H71.2004V165.7C71.2004 169.8 67.9004 173.1 63.8004 173.1C59.7004 173.1 56.4004 169.8 56.4004 165.7V0H236V166C236 205.9 205.2 239.4 165.8 242.3C165.6 242.4 165.4 242.4 165.2 242.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.5 65.5998H130C125.9 65.5998 122.6 62.2998 122.6 58.1998C122.6 54.0998 125.9 50.7998 130 50.7998H193.5C197.6 50.7998 200.9 54.0998 200.9 58.1998C200.9 62.2998 197.5 65.5998 193.5 65.5998Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.3 66.0004C106.5 66.0004 110 62.5004 110 58.2004C110 53.9004 106.5 50.4004 102.3 50.4004C98.0996 50.4004 94.5996 53.9004 94.5996 58.2004C94.5996 62.5004 98.0996 66.0004 102.3 66.0004Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.5 107.3H130C125.9 107.3 122.6 104 122.6 99.9C122.6 95.8 125.9 92.5 130 92.5H193.5C197.6 92.5 200.9 95.8 200.9 99.9C200.9 104 197.5 107.3 193.5 107.3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.3 107.6C106.5 107.6 110 104.1 110 99.8C110 95.5 106.5 92 102.3 92C98.0996 92 94.5996 95.5 94.5996 99.8C94.5996 104.2 98.0996 107.6 102.3 107.6Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M193.5 148.4H130C125.9 148.4 122.6 145.1 122.6 141C122.6 136.9 125.9 133.6 130 133.6H193.5C197.6 133.6 200.9 136.9 200.9 141C200.9 145.1 197.5 148.4 193.5 148.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.3 148.8C106.5 148.8 110 145.3 110 141C110 136.7 106.5 133.2 102.3 133.2C98.0996 133.2 94.5996 136.7 94.5996 141C94.5996 145.3 98.0996 148.8 102.3 148.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPedido);
export default __webpack_public_path__ + "static/media/iconPedido.8fe843599205fe49bf5b7d1acd062c87.svg";
export { ForwardRef as ReactComponent };